var render, staticRenderFns
import script from "./dBase.vue?vue&type=script&lang=js&"
export * from "./dBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261b9237",
  null
  
)

export default component.exports